module.exports = __webpack_public_path__ + "static/media/04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_06.e836d8b8.jpg";